import { generatePath } from 'react-router';
import { request } from '@lib/request';
import { FetchQrRegisterParamsDto } from '@api/qr-code/qr-code.dto';
import { QrRegisteredType } from '@typings/common';

const FETCH_QR_REGISTER = '/sbp/v2/qr/register';

export const fetchQrRegister = async (data: FetchQrRegisterParamsDto) => {
    const result = await request.post<QrRegisteredType>(generatePath(FETCH_QR_REGISTER), {
        ...data,
    });
    return result.data;
};
